/**************
 Global
 ***************/

//add new product to cart
//let formData = { quantity: 1, id: 794864229, properties: { 'Personalize': 'ZHM' } };
function addProduct(formData) {
    return fetch(`${Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//change an existing product in your cart
//let formData = { quantity: 1, id: 794864229 } or items: [{ quantity: 1, id: 794864229 }]
function changeCart(formData) {
    return fetch(`${Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

//update cart note or attributes (_ for attributes are hidden and __ are private)
//let formData = { note: 'This is a note about my order', attributes: { 'Gift wrap': 'Yes' } }
//let formData = {updates: { 794864229: 2, 794864230: 3 }}
function updateCart(formData) {
    return fetch(`${Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
        .then(data => data.json());
}

// download product
function downloadProduct(handle) {
    return fetch(`${Shopify.routes.root}products/${handle}.js`)
        .then(data => data.json());
}

// get cart
function getCart() {
    return fetch(`${Shopify.routes.root}cart.js`)
        .then(data => data.json());
}

// print price (515491 => $5,154.91)
function price(amountInCents, removeTrailingZeros = false) {
    // calculate total
    let total = (parseFloat(amountInCents) / 100).toFixed(2).toString();

    // add commas if needed
    total = total.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // remove trailing zeros
    if (removeTrailingZeros) {
        total = total.toString().replace(".00", "");
    }

    // return total
    return `${currency}${total}`;
}

// sleep
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**************
 Design mode open mini cart
 ***************/
if (Shopify.designMode) {
    // if a user clicks on the mini cart
    document.addEventListener('shopify:section:select', function (event) {
        // open mini cart
        if (event.detail.sectionId === 'theme-mini-cart') {
            openCart();
        }

        // if they deselect the mini cart
        if (event.detail.sectionId !== 'theme-mini-cart') {
            closeCart();
        }
    });
}




document.querySelectorAll('.review_slider_wpr').forEach((wrapper, index) => {
  const slider = wrapper.querySelector('.review_slider.swiper');
  const nextButton = wrapper.querySelector('.swiper-button-next.review_arrow');
  const prevButton = wrapper.querySelector('.swiper-button-prev.review_arrow');

  new Swiper(slider, {
    slidesPerView: 3,
    spaceBetween: 18,
    loop: true,
    navigation: {
      nextEl: nextButton,
      prevEl: prevButton,
    },
    breakpoints: {
      1080: { slidesPerView: 3 },
      768: { slidesPerView: 2 },
      0: { slidesPerView: 1 },
    },
  });
});

document.querySelectorAll('[scroll-to-review-section]').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.preventDefault()
    const target = document.querySelector('[data-oke-widget]');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
});

document.querySelectorAll('[scroll-to-pdp], .fiber-gummies-product, .sticky-atc-button a, .fiber-gummies-btn , .common_button').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    const href = btn.getAttribute('href');

    if (
      btn.hasAttribute('scroll-to-pdp') ||
      href === '#' ||
      href === '' ||
      href === null
    ) {
      e.preventDefault();

      const target = document.querySelector('tala-pdp');

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});

  document.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('.accordion_main').forEach((section) => {
      section.querySelectorAll('.accordion_item').forEach((item) => {
        const title = item.querySelector('.accordion_title'),
          info = item.querySelector('.accordion_content_wp');
        title.addEventListener('click', () => {
          item.classList.contains('active')
            ? ((info.style.maxHeight = null), item.classList.remove('active'))
            : (section.querySelectorAll('.accordion_item.active').forEach((openItem) => {
                if (openItem !== item) {
                  const openInfo = openItem.querySelector('.accordion_content_wp');
                  (openInfo.style.maxHeight = null), openItem.classList.remove('active');
                }
              }),
              (info.style.maxHeight = info.scrollHeight + 'px'),
              item.classList.add('active'));
        });
      });
    });
  });


  var science_slider = new Swiper(".science_slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination.science_pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next.science_arrow",
        prevEl: ".swiper-button-prev.science_arrow"
      }
    });

    var feature_bar_wpr = new Swiper(".feature_bar_wpr", {
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 5000,
      autoplay: {
        delay: 0
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          loop: true
        },
        1024: {
          slidesPerView: 4,
          loop: false
        }
      },
    });

    var Informational_wpr = new Swiper(".Informational_wpr", {
      slidesPerView: 'auto',
      spaceBetween: 30
    });


  document.querySelectorAll('.video-cards-slider .slide-inner').forEach(slide => {
  slide.addEventListener('click', () => {
    const video = slide.querySelector('video');
    if (!video) return;

    // Pause other videos FIRST
    document.querySelectorAll('.video-cards-slider video').forEach(v => {
      if (v !== video && !v.paused) {
        v.pause();
        v.currentTime = 0;
        v.closest('.slide-inner')?.classList.remove('active');
      }
    });

    // Toggle current video
    if (video.paused) {
      video.play().catch(() => {}); // prevent AbortError
      slide.classList.add('active');
    } else {
      video.pause();
      slide.classList.remove('active');
    }
  });
});


  new Swiper(".video-cards-slider", {
    loop: true,
    spaceBetween: 25,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next.video_arrow",
      prevEl: ".swiper-button-prev.video_arrow"
    },
    breakpoints: {
      0: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  });

  function equalizeIngredientsCols() {
  const wrapper = document.querySelector('.ingredients-wrap');
  if (!wrapper) return;

  const left = wrapper.querySelector('.col-left');
  const right = wrapper.querySelector('.col-right');
  if (!left || !right) return;

  // reset heights first (important for resize recalculation)
  left.style.height = 'auto';
  right.style.height = 'auto';

  // get heights
  const leftHeight = left.offsetHeight;
  const rightHeight = right.offsetHeight;

  const maxHeight = Math.max(leftHeight, rightHeight);

  // apply max height to both
  left.style.height = maxHeight + 'px';
  right.style.height = maxHeight + 'px';
}

// run on load
document.addEventListener('DOMContentLoaded', equalizeIngredientsCols);

// run on resize
window.addEventListener('resize', () => {
  equalizeIngredientsCols();
});


  document.querySelectorAll('.accordion-wpr, .product').forEach((section) => {
      const items = section.querySelectorAll('.accordion-item');

      items.forEach((item) => {
        const title = item.querySelector('.accordion-btn');
        const info = item.querySelector('.accordion-body');

        title.addEventListener('click', () => {
          const isActive = item.classList.contains('active');

          if (isActive) {
            // Close current
            info.style.maxHeight = null;
            item.classList.remove('active');
          } else {
            // Close all others
            section.querySelectorAll('.accordion-item.active').forEach((openItem) => {
              if (openItem !== item) {
                const openInfo = openItem.querySelector('.accordion-body');
                openInfo.style.maxHeight = null;
                openItem.classList.remove('active');
              }
            });

            // Open clicked
            info.style.maxHeight = info.scrollHeight + 'px';
            item.classList.add('active');
          }
        });
      });
    });

    document.querySelectorAll('.fiber_gummies_review_slider_wpr').forEach((wrapper, index) => {
    const slider = wrapper.querySelector('.fiber_gummies_review_slider.swiper');
    const nextButton = wrapper.querySelector('.swiper-button-next.fiber_gummies_review_arrow');
    const prevButton = wrapper.querySelector('.swiper-button-prev.fiber_gummies_review_arrow');

    new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 20,
      centeredSlides: true,
      loop: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      breakpoints: {
        1080: { slidesPerView: 3 },
        768: { slidesPerView: 2 },
        0: { slidesPerView: 1,spaceBetween: 10, },
      },
    });
  });

  new Swiper('.miniCartUpsellSlider', {
  slidesPerView: 1.2,
  spaceBetween: 16,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
    },
    768: {
      slidesPerView: 1.5,
    },
  },
  pagination: {
    el: '.miniCartUpsellPagination',
    clickable: true,
  },
});

var buyBtn = document.querySelector('.buy-button');
var stickyBtn = document.querySelector('.sticky-atc-button');
var talaPdp = document.querySelector('.tala-pdp');
var index = talaPdp ? parseInt(talaPdp.getAttribute('section-index')) : null;

if (stickyBtn) {
  if (buyBtn && index <= 3) {
    var observer = new IntersectionObserver(function(entries) {
      var entry = entries[0];

      if (entry.boundingClientRect.top < 0) {
        stickyBtn.classList.add('active');
      } else {
        stickyBtn.classList.remove('active');
      }
    }, {
      threshold: 0
    });

    observer.observe(buyBtn);

  } else {
    window.addEventListener('scroll', function() {
      var visible = false;

      if (buyBtn) {
        var rect = buyBtn.getBoundingClientRect();
        visible = rect.top < window.innerHeight && rect.bottom > 0;
      }

      if (window.scrollY > 400 && !visible) {
        stickyBtn.classList.add('active');
      } else {
        stickyBtn.classList.remove('active');
      }
    });
  }
}

document.addEventListener('click', function (e) {
  if (e.target.closest('kaching-bundle') || e.target.closest('.product-option-btn') ) {
    setTimeout(() => {
      const price = document.querySelector('tala-pdp .price')?.innerText.trim();
      const stickyPrice = document.querySelector('.sticky-atc-btn .cta-price');

      if (price && stickyPrice) {
        stickyPrice.innerText = price;
      }
    }, 1000);
  }
});


document.querySelectorAll('.image-popup').forEach(function(item) {
  item.addEventListener('click', function() {
    var imageUrl = item.getAttribute('data-image');

    if (!imageUrl) return;

    var popup = document.createElement('div');
    popup.className = 'image-popup-modal';
    popup.innerHTML = `
      <div class="image-popup-modal-inner">
        <span class="close-popup">&times;</span>
        <img src="${imageUrl}" alt="">
      </div>
    `;

    document.body.appendChild(popup);

    function closePopup() {
      popup.remove();
      document.removeEventListener('keydown', escClose);
    }

    function escClose(e) {
      if (e.key === 'Escape') {
        closePopup();
      }
    }

    document.addEventListener('keydown', escClose);

    popup.addEventListener('click', function(e) {
      if (
        e.target.classList.contains('image-popup-modal') ||
        e.target.classList.contains('close-popup')
      ) {
        closePopup();
      }
    });
  });
});


setTimeout(function () {
  var el = document.querySelector('#orderdate');

  if (el) {
    var d = new Date();
    d.setDate(d.getDate() + 1);

    var month = d.toLocaleString('en-US', { month: 'short' });
    var day = d.getDate();

    function suffix(n) {
      if (n > 3 && n < 21) return 'th';
      switch (n % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
      }
    }

    el.textContent = month + ' ' + day + suffix(day);
  }
}, 2000);

document.querySelector('.product-rating')?.addEventListener('click', function(e) {
  e.preventDefault();

  const target = document.querySelector('.fiber_gummies_review_section, .colostrum_review_cards');

  target?.scrollIntoView({
    behavior: 'smooth'
  });
});

